import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Params, RouterLink } from '@angular/router';
import { BoschUiLinkTargetType, BoschUiLinkType, BoschUiLinkSizeEnum } from './bosch-ui-link.model';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'bosch-ui-link',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './bosch-ui-link.component.html',
  styleUrls: ['./bosch-ui-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiLinkComponent implements AfterViewInit {
  @Input() href: string | null = null;
  @Input() routerLink: string | null = null;
  @Input() queryParams: Params | null = null;
  @Input() target: BoschUiLinkTargetType = '_self';
  @Input() type: BoschUiLinkType = null;
  @Input() size: BoschUiLinkSizeEnum = BoschUiLinkSizeEnum.S;
  @Input() highlight = false;
  @Input() disabled = false;

  linkSizMap = {
    [BoschUiLinkSizeEnum.S]: '-size-s',
    [BoschUiLinkSizeEnum.M]: '-size-m',
    [BoschUiLinkSizeEnum.L]: '-size-l',
    [BoschUiLinkSizeEnum.XL]: '-size-xl',
    [BoschUiLinkSizeEnum.XXL]: '-size-2xl',
    [BoschUiLinkSizeEnum.XXXL]: '-size-3xl',
    [BoschUiLinkSizeEnum.XXXXL]: '-size-4xl',
    [BoschUiLinkSizeEnum.XXXXXL]: '-size-5xl',
    [BoschUiLinkSizeEnum.XXXXXXL]: '-size-6xl',
  };

  hasIcon$ = new BehaviorSubject(false);

  constructor(private element: ElementRef) {}

  ngAfterViewInit(): void {
    const hasPrefix = !!this.element.nativeElement.querySelector('[prefix]');
    const hasPostfix = !!this.element.nativeElement.querySelector('[postfix]');
    this.hasIcon$.next(hasPrefix || hasPostfix);
  }
}
